import { render, staticRenderFns } from "./MintingNowActions.vue?vue&type=template&id=5ac2cdf6&"
import script from "./MintingNowActions.vue?vue&type=script&lang=js&"
export * from "./MintingNowActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports